import type { AgencyInformation } from '@/javascript/interfaces'

import type { ApiClient } from '../api'
import type { UserSeating } from './interfaces'

export async function getSubscriptionPreview(
	api: ApiClient,
	organizationType: string,
	organizationId: number,
	ordwaySubscriptionId: string,
	previewSessionId: string,
	addedSeats: number
): Promise<ApiSubscriptionPreviewResponse> {
	const path = `/api/sales/seat_upgrade/${ordwaySubscriptionId}.json`
	const response = await api.get<ApiSubscriptionPreviewResponse>(path, {
		added_seats: addedSeats.toString(),
		organization_id: organizationId.toString(),
		organization_type: organizationType,
		preview_session_id: previewSessionId,
	})

	return response.data
}

export async function getTrialDetails(
	api: ApiClient,
	id: string): Promise<ApiGetTrialDetailsResponse> {
	const path = `/api/agencies/${id}/sales/trial_details`
	const response = await api.get<ApiGetTrialDetailsResponse>(path)

	return response.data
}

export async function getUpgradeSetup(
	api: ApiClient,
	organizationType: string,
	organizationId: number
): Promise<UpgradeSetupApiResponse> {
	const path = `/api/sales/seat_upgrade.json`
	const response = await api.get<UpgradeSetupApiResponse>(path, {
		organization_id: organizationId.toString(),
		organization_type: organizationType,
	})

	return response.data
}

export async function postAddSeats(
	api: ApiClient,
	payload: ApiSubscriptionPayload
): Promise<ApiSubscriptionResponse> {
	const path = `/api/sales/seat_upgrade.json`
	const response = await api.post<ApiSubscriptionResponse>(path, payload)

	return response.data
}

export async function postRequestMoreSeats(
	api: ApiClient,
	organizationType: string,
	organizationId: number,
	ineligibilityCriteria: string[]
) {
	const path = `/api/sales/request_more_seats.json`

	await api.post(path, {
		ineligibility_criteria: ineligibilityCriteria,
		organization_id: organizationId.toString(),
		organization_type: organizationType,
	})
}

export interface ApiSubscriptionPayload {
	added_seats: number
	organization_id: number
	organization_type: string
	preview_session_id: string
}

export interface ApiSubscriptionResponse {
	add_seats_confirmation: ApiSubscriptionUpdateResponse
	message: string
}

export interface ApiSubscriptionUpdateResponse {
	contract_effective_date: string
	max_number_of_seats: number
	plan_name: string
	updated_monthly_cost: string
}

export interface ApiSubscriptionPreviewResponse {
	preview_session_id: string
	updated_monthly_cost: string
}
export interface ApiGetTrialDetailsResponse {
	data: {
		agency: AgencyInformation
	}
}

export interface UpgradeSetupApiResponse {
	billing_account_name: string
	current_monthly_cost: string
	ordway_subscription_id: string
	plan_name: string
	preview_session_id: string
	user_seating: UserSeating
}
